// Migrado a Material UI v5 con diseño mejorado y visualización de documentos en Card
import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DocumentosAdjuntos.css';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
 
  Grid,
  Typography,
  Link,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Divider
} from '@mui/material';

import {
  FaArrowLeft,
  
  FaPaperclip,
  FaFilePdf
} from 'react-icons/fa';

import { clearErrors } from '../../../redux/actions/dataactions';

function DocumentosAdjuntos(props) {
  const [open, setOpen] = useState(false);
 

 
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
   
    setOpen(false);
  };

  

  const documentos = [
    { key: 'urlmanual', label: 'Manual de Usuario' },
    { key: 'urlfactura', label: 'Factura' },
    { key: 'urlmanualservice', label: 'Manual de Servicio' },
    { key: 'urlimportacion', label: 'Declaración de Importación' },
    { key: 'urlregistroinvima', label: 'Registro INVIMA' },
    { key: 'urlactadeentrega', label: 'Acta de Entrega' },
    { key: 'urlcontratoalquiler', label: 'Contrato de Alquiler' },
    { key: 'urlcontratocomodato', label: 'Contrato Comodato' }
  ];

  return (
    <Fragment>
      <Tooltip title="Adjuntar Documentos">
        <IconButton onClick={handleOpen}>
          <FaPaperclip color="#03178C" className="icon-crearcliente" />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle><Typography sx={{ 
                                          fontSize: '20px', 
                                          fontWeight: 400, 
                                          color: '#0468BF', 
                                          textAlign: 'center' 
                                          }}>
                                          Documentos Adjuntos
                          </Typography></DialogTitle>

      
          <DialogContent>
            {props.equipo && (
              <>
                <Typography  sx={{ 
                                          fontSize: '20px', 
                                          fontWeight: 400, 
                                          color: '#0468BF', 
                                          textAlign: 'start' 
                                          }}  gutterBottom>Documentos Adjuntos:</Typography>
                <Grid container spacing={2}>
                  {documentos.map(doc => (
                    props.equipo[doc.key] && (
                      <Grid item xs={12} sm={6} key={doc.key}>
                        <Card variant="outlined">
                          <CardContent>
                            <Grid container alignItems="center" spacing={1}>
                              <Grid item>
                                <FaFilePdf color="#03178C" />
                              </Grid>
                              <Grid item xs>
                                <Typography variant="body1">
                                  <Link href={props.equipo[doc.key]} target="_blank" rel="noopener">
                                    {doc.label}
                                  </Link>
                                </Typography>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    )
                  ))}
                </Grid>
                <Divider className="my-2" />
              </>
            )}

            
          </DialogContent>
        
        <DialogActions>
          <Tooltip title="Cerrar">
            <IconButton onClick={handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </IconButton>
          </Tooltip>

         
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

DocumentosAdjuntos.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  
  UI: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired,
  equipoId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  user: state.user,
  equipo: state.data.equipo.credentials
});

export default connect(mapStateToProps, { clearErrors })(DocumentosAdjuntos);
